import { useState, useEffect, useRef, useCallback } from 'react';

export const useStickyHeader = (defaultSticky = false, topOffset = 80, bottomOffset = 68) => {
  const [isSticky, setIsSticky] = useState(defaultSticky);
  const tableRef = useRef(null);

  const toggleStickiness = useCallback(
    ({ top, bottom }) => {
      if (
        // Magic number for navigation height.
        top <= topOffset &&
        // When scrolling from bottom to top when and
        // the last row is visible enough, sticky header will be triggered.
        // This number (68) could be adjusted or skipped.
        bottom > 2 * bottomOffset
      ) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    },
    [isSticky],
  );

  useEffect(() => {
    const handleScroll = () => {
      if (tableRef.current)
        toggleStickiness(tableRef.current.getBoundingClientRect());
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [toggleStickiness]);

  return { tableRef, isSticky };
};
